import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  formData: {
    // e.g. name: '', photoId: '', etc.
  },
  currentStep: localStorage.getItem("currentStep") || 1,
  currentStepCorprate: localStorage.getItem("currentStepCorprate") || 1,
  currentStepShareholder: localStorage.getItem("currentStepShareholder") || 1,
  currentStepTrust: localStorage.getItem("currentStepTrust") || 1,
  showPopup: false,
  isEditPersonalDetails: false,
  stepStatus: JSON.parse(localStorage.getItem("stepStatus")) || [],
  stepStatusShareholder:
    JSON.parse(localStorage.getItem("stepStatusShareholder")) || [],
  rejectedFields: JSON.parse(localStorage.getItem("rejectedFields")) || {},
  rejectedFieldsShareholder:
    JSON.parse(localStorage.getItem("rejectedFieldsShareholder")) || {},
  individualAccountType:
    JSON.parse(localStorage.getItem("individualAccountType")) || 1,
  onboardingCustomer: localStorage.getItem("onboardingCustomer") || null,
  updateFieldStatus: false,

  //form fields start
  fields: {
    signatoryType: 1,
    signatoryEmail: "",
    selectedOptions: [],
    fileAttorney: {
      verification_id: null,
      value: null,
      status: "pending",
      rejection_reason: null,
      rejection_comment: null,
      rejection_timestamp: null,
      rejected_by: null,
      comments: [],
    },
    limitDurationId: 1,
    minimumInvestment: {
      verification_id: null,
      value: 0,
      status: "pending",
      rejection_reason: null,
      rejection_comment: null,
      rejection_timestamp: null,
      rejected_by: null,
      comments: [],
    },
    selected: "never",
    customDate: "",
    options: [],
  },
  //end
};
const setByPath = (obj, path, value) => {
  const keys = path.split(".");
  let current = obj;

  keys.slice(0, -1).forEach((key) => {
    if (!current[key]) current[key] = {};
    current = current[key];
  });

  current[keys[keys.length - 1]] = value;
};
const formSlice = createSlice({
  name: "form",
  initialState,
  reducers: {
    updateFormData: (state, action) => {
      const { field, value } = action.payload;
      state.formData[field] = value;
    },
    setFormData: (state, action) => {
      state.formData = action.payload;
    },
    resetFormData: (state) => {
      state.formData = {};
    },
    setCurrentStepRedux: (state, action) => {
      localStorage.setItem("currentStep", action.payload);
      state.currentStep = action.payload;
    },
    setCurrentStepCorprateRedux: (state, action) => {
      localStorage.setItem("currentStepCorprate", action.payload);
      state.currentStepCorprate = action.payload;
    },
    setCurrentStepTrustRedux: (state, action) => {
      localStorage.setItem("currentStepTrust", action.payload);
      state.currentStepTrust = action.payload;
    },
    setRejectedFields: (state, action) => {
      localStorage.setItem("rejectedFields", JSON.stringify(action.payload));
      state.rejectedFields = action.payload;
    },
    clearRejectedFields: (state) => {
      localStorage.removeItem("rejectedFields");
      state.rejectedFields = [];
    },
    setRejectedFieldsShareholder: (state, action) => {
      localStorage.setItem(
        "rejectedFieldsShareholder",
        JSON.stringify(action.payload),
      );
      state.rejectedFieldsShareholder = action.payload;
    },
    clearRejectedFieldsShareholder: (state) => {
      localStorage.removeItem("rejectedFieldsShareholder");
      state.rejectedFieldsShareholder = [];
    },
    setStepStatus: (state, action) => {
      localStorage.setItem("stepStatus", JSON.stringify(action.payload));
      state.stepStatus = action.payload;
    },
    clearStepStatus: (state) => {
      localStorage.removeItem("stepStatus");
      state.stepStatus = [];
    },
    clearCurrentStep: (state) => {
      localStorage.removeItem("currentStep");
      state.currentStep = 1;
    },
    clearCurrentStepCorprate: (state) => {
      localStorage.removeItem("currentStepCorprate");
      state.currentStepCorprate = 1;
    },
    clearCurrentStepTrust: (state) => {
      localStorage.removeItem("currentStepTrust");
      state.currentStepTrust = 1;
    },
    setShowPopupRedux: (state, action) => {
      // localStorage.setItem("currentStep", action.payload);
      state.showPopup = action.payload;
    },
    clearShowPopupStep: (state) => {
      localStorage.removeItem("currentStep");
      state.showPopup = false;
    },
    setIsEditPersonalDetailsRedux: (state, action) => {
      state.isEditPersonalDetails = action.payload;
    },
    clearIsEditPersonalDetails: (state) => {
      state.isEditPersonalDetails = false;
    },
    setCurrentStepShareholder: (state, action) => {
      localStorage.setItem("currentStepShareholder", action.payload);
      state.currentStepShareholder = action.payload;
    },
    clearCurrentStepShareholder: (state) => {
      localStorage.removeItem("currentStepShareholder");
      state.currentStepShareholder = 1;
    },
    setStepStatusShareholder: (state, action) => {
      localStorage.setItem(
        "stepStatusShareholder",
        JSON.stringify(action.payload),
      );
      state.stepStatusShareholder = action.payload;
    },
    clearStepStatusShareholder: (state) => {
      localStorage.removeItem("stepStatusShareholder");
      state.stepStatusShareholder = [];
    },
    updateField: (state, action) => {
      const { path, value } = action.payload;
      setByPath(state.fields, path, value);
    },

    bulkUpdateFields: (state, action) => {
      Object.entries(action.payload).forEach(([path, value]) => {
        setByPath(state.fields, path, value);
      });
    },

    resetFields: (state) => {
      state.fields = initialState.fields;
    },
    setIndividualAccountType: (state, action) => {
      localStorage.setItem("individualAccountType", action.payload);
      state.individualAccountType = action.payload;
    },
    clearIndividualAccountType: (state) => {
      localStorage.removeItem("individualAccountType");
      state.individualAccountType = null;
    },
    setOnboardingCustomer: (state, action) => {
      localStorage.setItem("onboardingCustomer", action.payload);
      state.onboardingCustomer = action.payload;
    },
    clearOnboardingCustomer: (state) => {
      localStorage.removeItem("onboardingCustomer");
      state.onboardingCustomer = null;
    },
    UpdateFieldStatusTrue: (state, action) => {
      state.updateFieldStatus = true;
    },
    UpdateFieldStatusFalse: (state) => {
      state.updateFieldStatus = false;
    },
  },
});

export const {
  updateFormData,
  setFormData,
  resetFormData,
  setCurrentStepRedux,
  clearCurrentStep,
  setShowPopupRedux,
  clearShowPopupStep,
  setIsEditPersonalDetailsRedux,
  clearIsEditPersonalDetails,
  setStepStatus,
  clearStepStatus,
  setRejectedFields,
  clearRejectedFields,
  setCurrentStepShareholder,
  clearCurrentStepShareholder,
  setStepStatusShareholder,
  clearStepStatusShareholder,
  setRejectedFieldsShareholder,
  clearRejectedFieldsShareholder,
  setCurrentStepCorprateRedux,
  clearCurrentStepCorprate,
  updateField,
  bulkUpdateFields,
  resetFields,
  setCurrentStepTrustRedux,
  clearCurrentStepTrust,
  setIndividualAccountType,
  clearIndividualAccountType,
  setOnboardingCustomer,
  clearOnboardingCustomer,
  UpdateFieldStatusFalse,
  UpdateFieldStatusTrue,
} = formSlice.actions;
export default formSlice.reducer;